<template>
  <v-tooltip top>
    <template #activator="{ on }">
      <div class="d-flex" v-on="on">
        <v-icon v-if="status && icon" :color="color" :small="emall">
          {{ icon }}
        </v-icon>
        <span v-else>-</span>

        <v-progress-circular
          v-if="(status == 'processing' || status == 'uploading') && progress"
          :value="progress"
          :color="color"
          small
          size="24"
          class="ml-2"
        />
      </div>
    </template>
    <span>{{ message }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'ButtonRecoveryStatus',
  props: {
    status: {
      type: String,
      required: false,
    },
    progress: {
      type: Number,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    color() {
      switch (this.status) {
        case 'scheduled':
        case 'received':
        case 'pending':
          return 'warning'
        case 'processing':
        case 'uploading':
          return 'info'
        case 'failed':
          return 'error'
        case 'completed':
        case 'validated':
        default:
          return 'primary'
      }
    },
    icon() {
      switch (this.status) {
        case 'scheduled':
        case 'received':
        case 'pending':
          return 'pending'
        case 'processing':
          return 'settings'
        case 'uploading':
          return 'cloud_uploads'
        case 'failed':
          return 'cancel'
        case 'completed':
          return 'offline_pin'
        case 'validated':
          return 'check_circle'
        default:
          return null
      }
    },
    message() {
      if (this.error) {
        return this.$t(`fields.matches.recovery-error.${this.error}`)
      } else if (this.progress) {
        return `${this.$t(`fields.matches.recovery-status.${this.status}`)} ${
          this.progress
        } %`
      } else {
        return this.$t(`fields.matches.recovery-status.${this.status}`)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.icongreen {
  color: #4caf50;
  background-color: transparent;
}

.iconred {
  color: red;
  background-color: transparent;
}
.iconyellow {
  color: orange;
  background-color: transparent;
}
.iconblue {
  color: #007fff;
  background-color: transparent;
}
</style>
